import {browserHistory} from 'react-router';
import axios from 'axios';


const baseEndpoint = 'v1/channels';
const baseEndpoint2 = 'v1/accounts';

const ChannelService = {

  deleteChannelCategory( id, categoryId ) {
    return axios
      .delete( `${baseEndpoint}/${id}/categories/${categoryId}` )
  },

  assignChannels( data ) {
    return axios
      .post( `${baseEndpoint}/assignees`, data )
  },

  dismissChannels( data ) {
    return axios
      .post( `${baseEndpoint}/dismiss`, data )
  },

  getChannel( id ) {
    return axios
      .get( `${baseEndpoint}/${id}` )
  },

  getChannelCases( id, accountId, params ) {
    return axios
      .get( `${baseEndpoint}/${id}/cases/${accountId}`, { params } )
  },

  getChannels( params ) {
    return axios
      .get( baseEndpoint, { params } )
  },
  //TODO: yasef
  saveChannelAccount( data ) {
    return axios
      .post( `${baseEndpoint2}`, data )
  },

  //ToDo review url
  saveChannelPhone( data ) {
    return axios
      .post( `${baseEndpoint}/phones`, data )
  },

  updateChannelStatus( id, data ) {
    return axios
      .put( `${baseEndpoint}/${id}/status`, data )
  },

  getChannelAttachments( id ) {
    return axios
      .get( `${baseEndpoint}/${id}/attachment` )
  },

  searchChannelByPhone( params ) {
    return axios
      .get( `${baseEndpoint}-phone`, { params } )
  },

  searchChannelByCriteria( params ) {
    return axios
      .get( `${baseEndpoint}-by-criteria`, {params})
  },

  saveChannelWalkin( data ) {
    return axios
      .post( `${baseEndpoint}/walk-in`, data )
  },

  getDismissReason() {
    return axios.get(`v1/dismiss-reasons`)
  }
};

export default ChannelService;



// WEBPACK FOOTER //
// ./services/ChannelService.js